var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99875,
    cy: 1.62766,
    r: 1.62766,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99875,
    cy: 1.62766,
    r: 1.62766,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99875,
    cy: 1.62766,
    r: 1.62766,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99875,
    cy: 1.62766,
    r: 1.62766,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99284,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99284,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99284,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99284,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 9.35313,
    r: 1.62174,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 1.62174,
    r: 1.62174,
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5036,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4821,
    cy: 15.8637,
    r: 1.62174,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.30372,
    y1: 0.813843,
    x2: 9.30372,
    y2: 8.13829,
    stroke: "white",
    strokeWidth: 0.610371
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.79298,
    y1: 8.54517,
    x2: 2.79298,
    y2: 15.8696,
    stroke: "white",
    strokeWidth: 0.610371
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.8145,
    y1: 8.13831,
    x2: 15.8145,
    y2: 15.4628,
    stroke: "white",
    strokeWidth: 0.610371
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.6953,
    y1: 9.66419,
    x2: 3.30172,
    y2: 9.66419,
    stroke: "white",
    strokeWidth: 0.610371
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.6953,
    y1: 1.93287,
    x2: 3.30172,
    y2: 1.93287,
    stroke: "white",
    strokeWidth: 0.610371
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/guides.b1011fed80af32b8fe0c5df0a68594e9.svg";
export { ForwardRef as ReactComponent };